// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3tJch","errorLogs":"styles_errorLogs__qOM2X"};